function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.01005 5.71906C5.2179 5.71739 5.41695 5.6349 5.56505 5.48906L9.40505 1.64906C9.55556 1.49922 9.64038 1.29572 9.64085 1.08333C9.64132 0.870948 9.55741 0.667076 9.40756 0.516564C9.25772 0.366053 9.05422 0.281235 8.84183 0.280764C8.62945 0.280293 8.42558 0.36421 8.27506 0.514055L5.00005 3.78905L1.72504 0.514055C1.57453 0.36421 1.37066 0.280293 1.15827 0.280764C0.94589 0.281235 0.742392 0.366053 0.592547 0.516564C0.442701 0.667076 0.358784 0.870948 0.359255 1.08333C0.359726 1.29572 0.444547 1.49922 0.595059 1.64906L4.43506 5.48906C4.51081 5.56368 4.60067 5.62245 4.6994 5.66195C4.79813 5.70144 4.90373 5.72085 5.01005 5.71906Z",
  fill: "#081F2D"
});

function SvgArrowSmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallIcon);
export default __webpack_public_path__ + "static/media/arrow-small-icon.fd97e376.svg";
export { ForwardRef as ReactComponent };